import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import {
  getQuickCreateGameModeProps,
  QuickCreateGameMode,
} from '../../../../models/DraftStore';
import { WebBoosterType } from '../../../../models/UserStore';
import { AppBar, SvgIcon } from '../../../Molecules';

import styles from './CopyScripturesTemplate.module.css';

const scriptureInfo = {
  englishNIV: {
    title: 'English (NIVUK)',
    url: 'https://www.bible.com/bible/111/GEN.1.NIV',
  },
  traditionalChineseCUNP: {
    title: 'Traditional Chinese (CUNP)',
    url: 'https://www.bible.com/bible/46/GEN.1.CUNP-%25E7%25A5%259E',
  },
  simplifiedChineseCUNPSS: {
    title: 'Simplified Chinese (CUNPSS)',
    url: 'https://www.bible.com/bible/48/GEN.1.CUNPSS-%25E7%25A5%259E',
  },
  japaneseKougoYaku: {
    title: 'Japanese (口語訳)',
    url: 'https://www.bible.com/bible/1820/GEN.1.%25E5%258F%25A3%25E8%25AA%259E%25E8%25A8%25B3',
  },
};

type CopyScripturesTemplateProps = {
  type: QuickCreateGameMode | undefined;
  webBoosterType: WebBoosterType | undefined;
  onClickBack: () => void;
};
export const CopyScripturesTemplate = (props: CopyScripturesTemplateProps) => {
  const { type, webBoosterType, onClickBack } = props;
  const { t } = useTranslation();
  return (
    <div className={styles.copyScriptures}>
      <AppBar
        title={
          type ? t(getQuickCreateGameModeProps(type, webBoosterType).name) : ''
        }
        onClickBack={onClickBack}
      />
      <div className={styles.container}>
        <p className={styles.title}>{t('Copy Scriptures')}</p>
        <p className={styles.description}>
          {t(
            'You may copy scriptures from below Bible versions to create Memory Practices.',
          )}
        </p>
        <div className={styles.scripturesList}>
          {Object.entries(scriptureInfo).map(([key, { title, url }]) => (
            <li key={key}>
              <a
                className={styles.whiteBar}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className={styles.whiteBarText}>{t(title)}</div>
                <div className={styles.whiteBarArrow}>
                  <SvgIcon
                    name={SVGIconType.Arrow}
                    color="#808080"
                    width={20}
                    height={20}
                  />
                </div>
              </a>
            </li>
          ))}
        </div>
        <div className={styles.scripturesList}>
          <p className={styles.sectionTitle}>{t('Others')}</p>
          <li key={'Others'}>
            <a
              className={styles.whiteBar}
              href={'https://www.bible.com/bible'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.whiteBarText}>{t('Online Bible')}</div>
              <div className={styles.whiteBarArrow}>
                <SvgIcon
                  name={SVGIconType.Arrow}
                  color="#808080"
                  width={20}
                  height={20}
                />
              </div>
            </a>
          </li>
        </div>
      </div>
    </div>
  );
};
